import React from 'react'
import { observer } from 'mobx-react';


import perso from '../../images/perso.png'
import './advisor-popup.css'

import PopupStore, { POPUPS_IDS } from '../../stores/PopupStore';

function AdvisorPopup({data}) {
  let content
  if(data && typeof data !== "string") {
    content = data.map((m, i) => <div key={i} dangerouslySetInnerHTML={{__html: m}} />)
  } else {
    content = <div dangerouslySetInnerHTML={{__html: data}} />
  }

  return (
    <div className="overlay advisor-container"  onClick={() => { PopupStore.close(POPUPS_IDS.ADVISOR) }}>
      <div className="advisor-popup">
        <img src={perso} alt=""/>
        <div className="content">{content}</div>
      </div>
    </div>
  )
}

export default observer(AdvisorPopup)
